import { Pipe, PipeTransform } from '@angular/core';
import {ItemConstraint} from '../../model/item-constraint';

@Pipe({
  name: 'geoarea'
})
export class GeoareaPipe implements PipeTransform {
  transform(item: ItemConstraint): { label: string, severity: string } {
    let label = '';
    let severity = '';

    switch (item.tier_type) {
      case 7:
        label = `Store ${item.tier_code}`;
        severity = 'success';
        break;
      case 15:
        label = `Sales Org ${item.tier_code}`;
        severity = 'danger';
        break;
      case 50:
        label = `Ecommerce ${item.tier_code}`;
        severity = 'info';
        break;
      default:
        label = `Unknown ${item.tier_code}`;
        severity = 'default';
        break;
    }

    return { label, severity };
  }
}
